import React from "react";
import { Flex, Text } from "@chakra-ui/react";

interface Props {
  label: string;
  // 서버가 아직 채우지 않은 값이 흔해 "-" 폴백을 컴포넌트에 내장한다.
  value?: string | null;
}

function PathPickOrderDetailInfoField({ label, value }: Props) {
  return (
    <Flex flexDirection={"column"} gap={"2px"} minWidth={0}>
      <Text textStyle={"caption-medium"} color={"#8F8F8C"}>
        {label}
      </Text>
      {/* 운송장 번호처럼 공백이 없는 긴 값이 좁은 칸을 밀어내지 않게 한다 */}
      <Text
        textStyle={"body-sm-bold"}
        color={"#1D1D1B"}
        wordBreak={"break-all"}
      >
        {value || "-"}
      </Text>
    </Flex>
  );
}

export default PathPickOrderDetailInfoField;
